import {Grid,TableBody,TableContainer,TableRow,Table,TableHead,withStyles,TableCell,makeStyles,DialogTitle,CircularProgress,Typography} from '@material-ui/core';
import React, { useEffect, useState, useMemo } from 'react';
import DialogComp from '../../../../Core/Modal/dialogModal';
import { GreenButton, SecondaryButton } from '../../../../Core/FormInput';
import formatters from '../../../../Core/Grid/inputFormatter';
import { useWindowSize } from '../../../../Core/Controls/ScreenResolution';
import { postTCardCalendarHoliday, GetTCardByBookingDate } from '../../../../Core/Service/TCard-Calendar-service.js';
import TCardDashboardModal from '../Dashboard/T-cardModal.jsx';
import UserHoliday from './UserHoliday.jsx';
import { AppStorage } from '../../../../Core/Service/storage-service';

const useStyles = makeStyles({
    TCardStatusRender: {
      cursor: 'pointer',
      position: 'relative'
    }
  });
  
  const StyledTableCell = withStyles((theme) => ({
    head: {
      fontSize: 16,
      padding: '2px 8px',
      color: '#f50057'
    },
    body: {
      fontSize: 14,
      padding: '2px 8px'
    }
  }))(TableCell);
  
  const StyledTableRow = withStyles((theme) => ({
    root: {
      height: '40px',
      '&:nth-of-type(odd)': {
        backgroundColor: '#F5F5F5'
      },
      cursor: 'pointer'
    }
  }))(TableRow);
  
  
  const TCardStatusRender = ({ color, status, tCardsID }) => {
    const portalSetting = AppStorage.getPortalSetting();
  
    const legendItems = useMemo(() => {
        if (!portalSetting) return [];
        return [
          {
                label: portalSetting?.portalSettingsCollectionDeliverText,
                background: portalSetting?.portalSettingsCollectionDeliverBgColor || 'black',
                color: portalSetting?.portalSettingsCollectionDeliverTextColor || 'white',
                st: 'cd'
            },
            {
                label: portalSetting?.portalSettingsCustomerWaitingText,
                background: portalSetting?.portalSettingsCustomerWaitingBgColor || 'black',
                color: portalSetting?.portalSettingsCustomerWaitingTextColor || 'white',
                st: 'waiting'
            },
            {
                label: portalSetting?.portalSettingsServiceText,
                background: portalSetting?.portalSettingsServiceBgColor || 'black',
                color: portalSetting?.portalSettingsServiceTextColor || 'white',
                st: 'service'
            },
            {
                label: portalSetting?.portalSettingsInspectionText,
                background: portalSetting?.portalSettingsInspectionBgColor || 'black',
                color: portalSetting?.portalSettingsInspectionTextColor || 'white',
                st: 'inspection'
            },
            {
                label: portalSetting?.portalSettingsMOTText,
                background: portalSetting?.portalSettingsMOTBgColor || 'black',
                color: portalSetting?.portalSettingsMOTTextColor || 'white',
                st: 'mot'
            },
            {
                label: portalSetting?.portalSettingsRepairText,
                background: portalSetting?.portalSettingsRepairBgColor || 'black',
                color: portalSetting?.portalSettingsRepairTextColor || 'white',
                st: 'repair'
            },
            {
                label: portalSetting?.portalSettingsNightShiftText,
                background: portalSetting?.portalSettingsNightShiftBgColor || 'black',
                color: portalSetting?.portalSettingsNightShiftTextColor || 'white',
                st: 'ns'
            },
            {
                label: portalSetting?.portalSettingsRecallJobText,
                background: portalSetting?.portalSettingsRecallJobBgColor || 'black',
                color: portalSetting?.portalSettingsRecallJobTextColor || 'white',
                st: 'recall'
            },
    
            {
                label: portalSetting?.portalSettingsTachoText,
                background: portalSetting?.portalSettingsTachoBgColor || 'black',
                color: portalSetting?.portalSettingsTachoTextColor || 'white',
                st: 'tacho'
            }
        ];
    }, [portalSetting]);
  
    const classes = useStyles();
  
    return (
      <div style={{ background: color }} className={classes.TCardStatusRender}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            {status && (
              <div
                style={{
                  display: 'grid',
                  rowGap: 2,
                  gridTemplateColumns: `repeat(${legendItems.length}, 1fr)`,
                  justifyContent: 'flex-end'
                }}
              >
                {legendItems.map((m) => {
                  if (status[m.st]) {
                    return (
                      <div key={m.st} style={{ margin: '0px 2px', textAlign: 'center' }}>
                        <Typography
                          style={{
                            fontSize: 12,
                            fontWeight: 600,
                            background: m.background,
                            color: m.color,
                            padding: 2,
                            minWidth: 30
                          }}
                        >
                          {m.label}
                        </Typography>
                      </div>
                    );
                  } else {
                    return (
                      <div key={m.st} style={{ margin: '0px 2px', textAlign: 'center' }}>
                        <Typography
                          style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: 'black',
                            padding: 2,
                            minWidth: 49
                          }}
                        ></Typography>
                      </div>
                    );
                  }
                })}
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    );
  };
  
  
  const ViewHoliday = ({ selectedDate, branchID, isHoliday, onClose }) => {
    const [state, setState] = useState({
      errors: {},
      deLinkList: [],
      list: [],
      modalData: {},
      loading: false
    });
    const [winWidth] = useWindowSize();
    const [addHoliday, setAddHoliday] = useState(false);
    const [addUserHoliday, setAddUserHoliday] = useState(false);
  
    const CallApiBydate = async () => {
      setState((prev) => ({ ...prev, loading: true }));
      let res = await GetTCardByBookingDate(selectedDate);
      if (res.success) {
        setState((prev) => ({ ...prev, list: res.data.tCards, loading: false }));
      } else {
        setState((prev) => ({ ...prev, loading: false }));
      }
    };
  
    useEffect(() => {
      if (selectedDate) {
        CallApiBydate();
      }
    }, [selectedDate]);
  
    const handleHoliday = async (holidayValue) => {
      setState((prev) => ({ ...prev, loading: true }));
      try {
        const data = {
          BranchID: branchID, 
          IsHoliday: holidayValue, 
          Date: selectedDate 
        };
        let res = await postTCardCalendarHoliday(data);
        if (res.data.success) {
          onClose(true); 
        } else {
          console.error(res.message);
        }
      } catch (error) {
        console.error('Error submitting holiday data:', error);
      } finally {
        setState((prev) => ({ ...prev, loading: false }));
      }
    };
  
    const RenderTitle = () => {
      return (
        <Grid container spacing={1} direction="row" alignItems="center">
          <Grid item xs={6}>
            <DialogTitle style={{ padding: 0, margin: 0 }}>
              Holiday Calendar - {formatters.DateFormatter(selectedDate)}
            </DialogTitle>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            <Grid container spacing={1} direction="row" justifyContent="flex-end">
              <Grid item>
                {isHoliday ? (
                  <SecondaryButton onClick={() => handleHoliday(false)} style={{ whiteSpace: 'nowrap' }}>
                    Remove Branch Holiday
                  </SecondaryButton>
                ) : (
                  <GreenButton onClick={() => handleHoliday(true)} style={{ whiteSpace: 'nowrap', color: 'white' }}>
                    Add Branch Holiday
                  </GreenButton>
                )}
              </Grid>
              <Grid item>
                <GreenButton
                  onClick={() => setAddUserHoliday(true)}
                  style={{ whiteSpace: 'nowrap', color: 'white', minWidth: '140px' }}
                >
                  User Holiday
                </GreenButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    };
  
    const handelModalClose = (cond, id, res) => {
      setState((st) => ({ ...st, tCardID: id }));
      res && CallApiBydate();
      setAddHoliday(cond);
    };
  
    return (
      <DialogComp onClose={() => onClose(false)} title={RenderTitle()} maxWidth="lg" fullWidth>
        {state.loading ? (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '64vh' }}>
            <CircularProgress />
          </Grid>
        ) : (
          <Grid container spacing={2} style={{ paddingBottom: 6 }}>
            <TableContainer
              style={{
                border: '1px solid rgba(0,0,0,0.2)',
                height: 'calc(100vh - 455px)'
              }}
              className="custom-scroll"
            >
              <Table>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell width={50}>ID</StyledTableCell>
                    <StyledTableCell width={100}>Reg No</StyledTableCell>
                    <StyledTableCell width={250}>Customer</StyledTableCell>
                    <StyledTableCell width={350}>T-Card Items</StyledTableCell>
                    <StyledTableCell width={200}>Status</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {state.list.map((m) => (
                    <StyledTableRow
                      key={m.tCardsID}
                      onClick={() => handelModalClose(true, m.tCardsID, false)}
                    >
                      <StyledTableCell style={{ marginTop: 5 }}>{m.tCardsID}</StyledTableCell>
                      <StyledTableCell style={{ cursor: 'pointer', fontWeight: 600, marginTop: 5 }}>
                        {m.reg}
                      </StyledTableCell>
                      <StyledTableCell style={{ marginTop: 5 }}>{m.cust}</StyledTableCell>
                      <StyledTableCell style={{ marginTop: 5 }}>
                        <TCardStatusRender
                          status={{
                            recall: m.recall,
                            tacho: m.tacho,
                            mot: m.mot,
                            repair: m.repair,
                            inspection: m.inspection,
                            cd: m.cd,
                            waiting: m.waiting,
                            service: m.service,
                            ns: m.ns
                        }}
                        />
                      </StyledTableCell>
                      <StyledTableCell style={{ marginTop: 5 }}>{m.status}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {addHoliday && (
              <TCardDashboardModal id={state.tCardID} onClose={handelModalClose} />
            )}
            {addUserHoliday && (
              <DialogComp
                title="Add User Holiday"
                onClose={() => setAddUserHoliday(false)}
                maxWidth="md"
                fullWidth
              >
                <div style={{ padding: '20px' }}>
                  <UserHoliday 
                    selectedDate={selectedDate}           
                    branchID={branchID}              
                    onClose={() => setAddUserHoliday(false)}
                  />
                </div>
              </DialogComp>
            )}
          </Grid>
        )}
      </DialogComp>
    );
  };
  
  export default ViewHoliday;